import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    btn: {
      marginTop: '30px',
      width: '40%',
    },
    container: {
      padding: '50px 40px',
      width: '762px',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    message: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '1rem',
      textAlign: 'center',
    },
    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      padding: '18px 14px',
      textAlign: 'left',
      width: '222px',
    },
    statsText: {
      color: '#999999',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    statsTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '16px',
    },
  };
});
export default ({ patientName, materialCount, onCancel, onConfirm }) => {
  const classes = useStyles();
  return (
    <Container disableGutters className={classes.container}>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Typography variant="h4" className={`page-header ${classes.formTitle}`} align="center">
            You are about to submit this video report
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" className={`body-copy ${classes.message}`} align="center">
            You are about to submit this video report which will be sent to the patient.
          </Typography>
        </Grid>
        <Grid container item xs={12} justify="center">
          <Grid container className={classes.statsContainer}>
            <Grid item xs={12} className="mb-1">
              <Typography className={classes.statsTitle}>Patient Name</Typography>
              <Typography className={classes.statsText}> {patientName} </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.statsTitle}>Supplementary Material</Typography>
              <Typography className={classes.statsText}>{materialCount}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className="mt-1">
          <Typography variant="body1" className={`body-copy ${classes.message}`} align="center">
            The patient will be notiffied via email once the video report is submitted.
          </Typography>
        </Grid>
        <Button variant="outlined" style={{ width: '136px' }} size="medium" color="primary" onClick={onCancel} className={classes.btn}>
          Cancel
        </Button>
        <Button style={{ marginLeft: '5%', width: '136px' }} variant="contained" size="medium" color="primary" onClick={onConfirm} className={classes.btn}>
          Confirm
        </Button>
      </Grid>
    </Container>
  );
};
